import React from 'react';
import { useConsentService } from '@aviv-csnt/react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { ThemeProvider } from '@emotion/react';
import { theme } from '@ma-react/styles';

import thor from 'helpers/Thor';

import App from './containers/App';
import Routing from './Routing';

const Root = ({ store }) => {
    const { isConsentGranted } = useConsentService('gxmp7r7GKwtteD', {
        enableTCF: false,
    });

    if (isConsentGranted) {
        thor.onConsent();
    }

    return (
        <Provider store={store}>
            <ThemeProvider theme={theme}>
                <App>
                    <Routing />
                </App>
            </ThemeProvider>
        </Provider>
    );
};

Root.displayName = 'Root';

Root.propTypes = {
    store: PropTypes.shape({}),
};

/**
 * Root Functional Component.
 */
export default Root;
